import { makeAutoObservable } from "mobx";

class UserInfostate {
  isOpen: boolean = false;
  info = {}
  
  constructor() {
    makeAutoObservable(this);
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }

  show(state: boolean) {
    this.isOpen = state;
  }

}

export default new UserInfostate();
